import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { useTollFreeStepsContext } from 'pages/settings/pages/compliance/pages/tollFree/context/tollFreeStepsContext'

export const RegistrationErrorAlert = observer(() => {
  const {
    useCaseDetailsStore: { rejectedReason, deniedDesc, learnMoreModalAction },
  } = useTollFreeStepsContext()

  if (!rejectedReason || !deniedDesc) return null

  return (
    <Alert
      marginTop={20}
      marginBottom={32}
      item={{
        type: 'error',
        title: rejectedReason,
        desc: deniedDesc,
      }}
      actions={[
        {
          variant: 'button',
          type: 'secondary',
          text: 'Learn more',
          onClick: learnMoreModalAction,
        },
      ]}
    />
  )
})
